//import Vue from "*.vue";
//import router from '../router';
import VueRouter, { NavigationGuard, Route, RouteConfig } from "vue-router";
import Vue from "vue/types/umd";
import IRouteMiddleware from "./IRouteMiddleware";

export default class MiddlewareProcessor {
  constructor(private readonly router: VueRouter) {
    this.beforeEach(router);
    this.afterEach(router);
  }
  /**
   * Обработчик для конвеера
   * @param context 
   * @param middlewares 
   * @param index 
   * @returns 
   */
  private pipeline(context: any, middlewares: Array<IRouteMiddleware>, index: number) {
    const nextMiddleware = middlewares[index];
    if(!nextMiddleware){
        return context.next 
    }
    return () => {
        const nextPipeline = this.pipeline(
            context, middlewares, index + 1
        )
        nextMiddleware.process({ ...context, next: nextPipeline });
    }
  }
  /**
   * Получить список маршрутов от самого рутового, до дочернего
   * Проходится по дереву маршрутов и собирает в одномерный массив
   * @param routeName 
   * @param routesToSearch 
   * @returns 
   */
  private getRecursiveRouteConfigs(routeName: string, routesToSearch: RouteConfig[]): RouteConfig[] {
    let result = new Array<RouteConfig>();
    for (let index = 0; index < routesToSearch.length; index++) {
      const element = routesToSearch[index];
      if (element.name == routeName) {
        result.push(element);
      } else {
        if ((element.children || []).length > 0) {
          const childsFind = this.getRecursiveRouteConfigs(routeName, element.children);
          if (childsFind.length > 0) {
            result = result.concat([element, ...childsFind]);
          }
        }
      }
    }
    return result;
  }
  /**
   * Собрать все middleware'ы из списка роутов отсортированных от дочернего к родительскому (дочерние приоритетны)
   * @param routes 
   * @returns 
   */
  private collectMiddlewares(routes: RouteConfig[]) {
    let middlewares = new Array<IRouteMiddleware>();
    routes.forEach(route => {
      const currentMiddlewares = ((route.meta || {}).middleware || []) as IRouteMiddleware[];
      // из уже собранных middleware'в выкинем обработчики, которые есть в следующем маршруте (дочернем)
      // т.е. если будет обработчик типа Auth в родительском роуте и дочернем - сработает дочерний
      middlewares = middlewares.filter(x =>
         !currentMiddlewares.some(c => c.hookCallTime == x.hookCallTime && typeof(c) == typeof(x)));         
      if (currentMiddlewares.length > 0) {
        middlewares = middlewares.concat(currentMiddlewares);
      }
    })
    return middlewares;
  }
  /**
   * Возвращает обработчики для типа маршрута
   * @param to 
   * @param type 
   * @returns 
   */
  private getMiddlewares(to: Route, type: 'after' | 'before'): IRouteMiddleware[] {
    const routeTree = this.getRecursiveRouteConfigs(to.name, (this.router as any).options.routes);
    const middlewares = this.collectMiddlewares(routeTree);    
    return (middlewares || []).filter((x: IRouteMiddleware) => x.hookCallTime == type);
  }
  /**
   * Непосредственная обработка хуков маршрутов
   * @param hookRouteType 
   * @param to 
   * @param from 
   * @param next 
   * @returns 
   */
  private processRouteHookMiddlewares(hookRouteType: 'after' | 'before', to: Route, from: Route, next?: Function): any {
    const middlewares = this.getMiddlewares(to, hookRouteType);
    if (middlewares.length != 0) {
      const context = {
        to,
        from,
        next
      };
      return middlewares[0].process({
        ...context,
        next: this.pipeline(context, middlewares, 1)
      })
    } else {
      next && next();
      return;
    }
  }
  async afterEach(router: VueRouter) {
   router.afterEach((to: Route, from: Route) =>
    this.processRouteHookMiddlewares('after', to, from));
  }
  async beforeEach(router: VueRouter) {
    router.beforeEach((to: Route, from: Route, next: Function) => 
      this.processRouteHookMiddlewares('before', to, from, next));
  }
}